import { Button,Input, Tabs, TabItem } from 'components/atoms/index';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSlugPrefix } from '@/utils/slug';
import ExamTable from '@/components/organisms/Table/ExamTable';

// 로그인 페이지
export default function StudentExamList() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const slugPrefix = getSlugPrefix(pathname);
    
    const tabItems: TabItem[] = [
        { id: `${slugPrefix}/mypage/info`, label: '기본정보',onClick: () => navigate(`${slugPrefix}/mypage/info`) },
        { id: `${slugPrefix}/mypage/homework`, label: '숙제 채점표',onClick: () => navigate(`${slugPrefix}/mypage/homework`) },
        { id: `${slugPrefix}/mypage/exam`, label: '시험 성적표',onClick: () => navigate(`${slugPrefix}/mypage/exam`) },
        { id: `${slugPrefix}/mypage/trophy_badge`, label: '트로피 및 뱃지',onClick: () => navigate(`${slugPrefix}/mypage/trophy_badge`) },
      ];

  return (
    <main className='flex flex-1 pt-8 w-full bg-white md:my-10 md:justify-center card md:py-5 md:bg-transparent'>
        <div className='flex flex-col flex-1 w-full'>
            <h1 className='px-5 pb-3 heading1'>마이페이지</h1>
            <Tabs tabs={tabItems} activeId={pathname}  />
            <div className='flex flex-1 px-5 w-full lg:px-0'>
                <ExamTable />
            </div>
        </div>
    </main>
  )
}